/** @jsx jsx */

import { jsx } from '@emotion/core';

import Link from 'app/common/components/Link';
import { PLATFORM_MARKETING_BASE_URL } from 'app/developer-v3/constants';

import MultiSelectCheckboxes from './MultiSelectCheckboxes';
import { sectionStyle } from './constants';

type Props = {
  handleCheckBox: (key: string) => () => void;
  tos: boolean;
};

function SectionTos({ tos, handleCheckBox }: Props) {
  const options = [
    {
      checked: tos,
      name: (
        <span>
          I agree to the{' '}
          <Link href={`${PLATFORM_MARKETING_BASE_URL}/tos`} target="_blank">
            Zapier Platform Agreement
          </Link>
        </span>
      ),
      onKeyPress: handleCheckBox('tos'),
      value: 'tos',
    },
  ];

  return (
    <div css={sectionStyle}>
      <MultiSelectCheckboxes
        isRequired={true}
        options={options}
        title="Zapier Platform Agreement"
      />
    </div>
  );
}

export default SectionTos;
